<!--suppress HtmlFormInputWithoutLabel -->
<template>
  <div>
    <GridAutoColumns>
      <template v-for="(choice,i) in choices">
        <div :class="{'child':choice.hasOwnProperty('childLevel')}">
          <label :for="choice.value">
            <input :key="i" :id="choice.value" type="radio" :value="choice.value" v-model="localValue" :required="required">
            <RadioSvg :key="`${i}-${choice.value}`" :state="localValue === choice.value"/>
            {{ choice.label }}</label>
        </div>
      </template>
    </GridAutoColumns>
  </div>
</template>

<script>
import GridAutoColumns from "@/components/partials/layout/GridAutoColumns";
import RadioSvg from "@/components/icons/RadioSvg";

export default {
  name: "InputRadios",
  components: {RadioSvg, GridAutoColumns},
  props: {
    choices: {
      type: Array,
      required: true,
    },
    value: {
      type: String | Number,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: null,
    }
  },
  watch: {
    localValue(val) {
      this.$emit('update:value', val)
    },
    value(val) {
      this.localValue = val
    },
  },
  beforeMount() {
    this.localValue = this.value
  },
}
</script>

<style scoped lang="scss">
.child {
  margin-left: 2rem;
}

label {
  cursor: pointer;

  [type="radio"] {
    height: 0;
    width: 0;
    opacity: 0;
  }
}
</style>
